export function getManualNumericFacetInitialState() {
    return {};
}
